// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbar_toolbar__q-Ri+","list":"toolbar_list__vJ4hW","toolbar-button":"toolbar_toolbar-button__mPYTu","label":"toolbar_label__AQ3U3","tab":"toolbar_tab__Lae4F"};